import React from 'react';
import {
  EVENT_ITEM_LABEL,
  ABOUT_PAGE_EVENT_NAMES,
} from 'src/general/constants/enums';

import {
  AboutHero,
  AboutGetMoments,
  AboutLaLigaEvents,
  AboutLaligaMoments,
  AboutMomentRarity,
  AboutMomentsUsage,
} from './Sections';

export const AboutPageContent: React.FC<any> = ({
  aboutHero,
  aboutRareMoment,
  aboutGetMoments,
  aboutLaLigaEvents,
  aboutMomentsUsage,
  aboutLaLigaMoment,
  trackHandler,
}) => {
  return (
    <>
      <AboutHero
        {...aboutHero}
        secondaryVideoContentUrl={
          aboutHero.secondaryVideoContent.fields.file.url
        }
        trackEventName={ABOUT_PAGE_EVENT_NAMES.ABOUT_ITEM_CLICK}
        trackHandler={trackHandler}
        trackItemLabel={EVENT_ITEM_LABEL.WATCH_TRAILER}
        videoContent={aboutHero.videoContent.fields.file.url}
      />
      <AboutLaligaMoments {...aboutLaLigaMoment} trackHandler={trackHandler} />
      <AboutMomentRarity {...aboutRareMoment} />
      <AboutGetMoments {...aboutGetMoments} />
      <AboutMomentsUsage {...aboutMomentsUsage} />
      <AboutLaLigaEvents {...aboutLaLigaEvents} />
      {/* Hiding testimonials as Per Paulo */}
      {/* <AboutTestimonials {...aboutTestimonials} /> */}
    </>
  );
};
